import React from "react";
import PointOfSaleCore from "../../components/PointOfSale/Core/index";
import RestaurantCallCenter from "./RestaurantCallCenter";
import ModuleGate from "../ModuleGate";

const CallCenter = () => (
  <ModuleGate module="callCenter">
    <PointOfSaleCore component={RestaurantCallCenter} />
  </ModuleGate>
);

export default CallCenter;
